<template>
  <div id="logo">
    <svg
      id="Layer_1"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 266.09 40"
      style="enable-background: new 0 0 266.09 40;"
      xml:space="preserve"
    >
      <g transform="translate(-1.7 0.5)">
        <path
          id="Path_1"
          :fill="titleColor"
          d="M13.32,14.25c0.01,0.26-0.19,0.48-0.46,0.49c-0.01,0-0.03,0-0.04,0H9.94c-0.24,0.03-0.46-0.13-0.49-0.37c-0.01-0.04-0.01-0.08,0-0.12v-2.31c0.07-0.57-0.35-1.09-0.92-1.15c-0.08-0.01-0.16-0.01-0.24,0H6.81c-0.57-0.06-1.09,0.35-1.15,0.92c-0.01,0.08-0.01,0.16,0,0.24v13.18C5.59,25.7,6,26.21,6.57,26.28c0.08,0.01,0.16,0.01,0.24,0h1.48c0.57,0.06,1.09-0.35,1.15-0.92c0.01-0.08,0.01-0.16,0-0.24v-2.31c-0.01-0.26,0.19-0.48,0.46-0.49c0.01,0,0.03,0,0.04,0h2.88c0.24-0.03,0.46,0.13,0.49,0.37c0.01,0.04,0.01,0.08,0,0.12v3.13c0,2.72-1.48,4.12-4.12,4.12H5.9c-2.72,0-4.2-1.48-4.2-4.12V11.12C1.7,8.4,3.18,7,5.9,7h3.22c2.72,0,4.12,1.48,4.12,4.12v3.13H13.32z"
        />
        <path
          id="Path_2"
          :fill="titleColor"
          d="M26.75,30.07c-0.24-0.01-0.44-0.18-0.49-0.41l-0.82-4.2h-5.11l-0.74,4.2c-0.08,0.25-0.17,0.41-0.49,0.41h-3.05c-0.33,0-0.49-0.17-0.41-0.49L20.4,7.41C20.49,7.08,20.65,7,20.9,7h4.04c0.25,0,0.41,0.08,0.49,0.41l4.78,22.16c0.08,0.33-0.08,0.49-0.41,0.49L26.75,30.07z M22.88,12.03l-1.81,10.05h3.71L22.88,12.03z"
        />
        <path
          id="Path_3"
          :fill="titleColor"
          d="M48.09,7c0.41,0,0.58,0.16,0.58,0.58v21.92c0,0.41-0.17,0.58-0.58,0.58h-2.72c-0.41,0-0.58-0.17-0.58-0.58V16.48h-0.17l-2.89,13.02c-0.08,0.41-0.25,0.58-0.58,0.58h-1.4c-0.31,0.02-0.59-0.19-0.66-0.49l-2.88-13.02h-0.17v13.02c0,0.41-0.17,0.58-0.58,0.58h-2.64c-0.41,0-0.58-0.17-0.58-0.58v-22C32.19,7.16,32.43,7,32.76,7h3.79c0.31-0.02,0.59,0.19,0.66,0.49l3.21,14.34l3.21-14.34C43.7,7.19,43.98,6.98,44.3,7H48.09z"
        />
        <path
          id="Path_4"
          :fill="titleColor"
          d="M51.55,7.49C51.54,7.23,51.74,7.01,52,7c0.01,0,0.03,0,0.04,0h6.92c2.72,0,4.12,1.48,4.12,4.12v7c0,2.72-1.48,4.12-4.12,4.12H55.5v7.25c0.03,0.24-0.13,0.46-0.37,0.49c-0.04,0.01-0.08,0.01-0.12,0h-2.97c-0.24,0.03-0.46-0.13-0.49-0.37c-0.01-0.04-0.01-0.08,0-0.12V7.49L51.55,7.49z M57.97,18.53c0.57,0.06,1.09-0.35,1.15-0.92c0.01-0.08,0.01-0.16,0-0.24v-5.44c0.06-0.57-0.35-1.09-0.92-1.15c-0.08-0.01-0.16-0.01-0.24,0H55.5v7.74L57.97,18.53z"
        />
        <path
          id="Path_5"
          :fill="titleColor"
          d="M73.05,7c2.72,0,4.12,1.48,4.12,4.12v3.05c0.01,0.26-0.19,0.48-0.46,0.49c-0.01,0-0.03,0-0.04,0h-2.97c-0.24,0.03-0.46-0.13-0.49-0.37c-0.01-0.04-0.01-0.08,0-0.12v-2.23c0.06-0.57-0.35-1.09-0.92-1.15c-0.08-0.01-0.16-0.01-0.24,0h-1.4c-0.57-0.06-1.09,0.35-1.15,0.92c-0.01,0.08-0.01,0.16,0,0.24v3.96l6.84,2.23c0.48,0.12,0.79,0.58,0.74,1.07v6.75c0,2.72-1.48,4.12-4.12,4.12h-3.21c-2.72,0-4.12-1.48-4.12-4.12V22.9c-0.03-0.24,0.13-0.46,0.37-0.49c0.04-0.01,0.08-0.01,0.12,0h2.97c0.24-0.03,0.46,0.13,0.49,0.37c0.01,0.04,0.01,0.08,0,0.12v2.23c-0.06,0.57,0.35,1.09,0.92,1.15c0.08,0.01,0.16,0.01,0.24,0h1.4c0.57,0.06,1.09-0.35,1.15-0.92c0.01-0.08,0.01-0.16,0-0.24v-3.87l-6.84-2.23c-0.48-0.12-0.79-0.58-0.74-1.07v-6.84C65.72,8.4,67.2,7,69.84,7H73.05z"
        />
        <path
          id="Path_6"
          :fill="titleColor"
          d="M91.67,14.25c0.01,0.26-0.19,0.48-0.46,0.49c-0.01,0-0.03,0-0.04,0h-2.88c-0.24,0.03-0.46-0.13-0.49-0.37c-0.01-0.04-0.01-0.08,0-0.12v-2.31c0.06-0.57-0.35-1.09-0.92-1.15c-0.08-0.01-0.16-0.01-0.24,0h-1.48c-0.57-0.06-1.09,0.35-1.15,0.92c-0.01,0.08-0.01,0.16,0,0.24v13.18c-0.06,0.57,0.35,1.09,0.92,1.15c0.08,0.01,0.16,0.01,0.24,0h1.48c0.57,0.06,1.09-0.35,1.15-0.92c0.01-0.08,0.01-0.16,0-0.24v-2.31c-0.01-0.26,0.19-0.48,0.46-0.49c0.01,0,0.03,0,0.04,0h2.88c0.26-0.01,0.48,0.19,0.49,0.46c0,0.01,0,0.03,0,0.04v3.13c0,2.72-1.48,4.12-4.12,4.12h-3.21c-2.72,0-4.2-1.48-4.2-4.12V11.12c0-2.72,1.48-4.12,4.2-4.12h3.21c2.72,0,4.12,1.48,4.12,4.12L91.67,14.25z"
        />
        <path
          id="Path_7"
          :fill="titleColor"
          d="M105.1,30.07c-0.24-0.01-0.44-0.18-0.49-0.41l-0.82-4.2h-5.11l-0.74,4.2c-0.08,0.25-0.17,0.41-0.49,0.41h-3.05c-0.33,0-0.49-0.17-0.41-0.49l4.78-22.16C98.84,7.08,99,7,99.25,7h4.04c0.25,0,0.41,0.08,0.49,0.41l4.78,22.16c0.08,0.33-0.08,0.49-0.41,0.49L105.1,30.07z M101.23,12.03l-1.81,10.05h3.71L101.23,12.03z"
        />
        <path
          id="Path_8"
          :fill="titleColor"
          d="M111.12,7.49c-0.01-0.26,0.19-0.48,0.46-0.49c0.01,0,0.03,0,0.04,0h6.92c2.72,0,4.12,1.48,4.12,4.12v7c0,2.72-1.48,4.12-4.12,4.12h-3.46v7.25c0.03,0.24-0.13,0.46-0.37,0.49c-0.04,0.01-0.08,0.01-0.12,0h-2.97c-0.26,0.01-0.48-0.19-0.49-0.46c0-0.01,0-0.03,0-0.04L111.12,7.49L111.12,7.49z M117.62,18.53c0.57,0.06,1.09-0.35,1.15-0.92c0.01-0.08,0.01-0.16,0-0.24v-5.44c0.06-0.57-0.35-1.09-0.92-1.15c-0.08-0.01-0.16-0.01-0.24,0h-2.55v7.74L117.62,18.53z"
        />
        <path
          id="Path_9"
          :fill="titleColor"
          d="M137.07,10.38c0.04,0.24-0.13,0.46-0.36,0.49c-0.04,0.01-0.09,0.01-0.13,0h-7.25v5.77h5.52c0.24-0.03,0.46,0.13,0.49,0.37c0.01,0.04,0.01,0.08,0,0.12v2.88c0.03,0.24-0.13,0.46-0.37,0.49c-0.04,0.01-0.08,0.01-0.12,0h-5.52v5.85h7.25c0.24-0.03,0.46,0.13,0.49,0.37c0.01,0.04,0.01,0.08,0,0.12v2.88c0,0.33-0.08,0.49-0.49,0.49h-10.63c-0.25,0-0.41-0.17-0.41-0.49V7.49c-0.02-0.25,0.16-0.47,0.41-0.49h10.63c0.24-0.03,0.46,0.13,0.49,0.37c0.01,0.04,0.01,0.08,0,0.12L137.07,10.38z"
        />
        <path
          id="Path_10"
          :fill="titleColor"
          d="M146.46,7c2.72,0,4.12,1.48,4.12,4.12v3.05c0.01,0.26-0.19,0.48-0.46,0.49c-0.01,0-0.03,0-0.04,0h-2.97c-0.26,0.01-0.48-0.19-0.49-0.46c0-0.01,0-0.03,0-0.04v-2.23c0.06-0.57-0.35-1.09-0.92-1.15c-0.08-0.01-0.16-0.01-0.24,0h-1.4c-0.57-0.06-1.09,0.35-1.15,0.92c-0.01,0.08-0.01,0.16,0,0.24v3.96l6.84,2.23c0.48,0.12,0.79,0.58,0.74,1.07v6.75c0,2.72-1.48,4.12-4.12,4.12h-3.22c-2.72,0-4.12-1.48-4.12-4.12V22.9c-0.03-0.24,0.13-0.46,0.37-0.49c0.04-0.01,0.08-0.01,0.12,0h2.97c0.24-0.03,0.46,0.13,0.49,0.37c0.01,0.04,0.01,0.08,0,0.12v2.23c-0.06,0.57,0.35,1.09,0.92,1.15c0.08,0.01,0.16,0.01,0.24,0h1.4c0.57,0.06,1.09-0.35,1.15-0.92c0.01-0.08,0.01-0.16,0-0.24v-3.87l-6.84-2.23c-0.48-0.12-0.79-0.58-0.74-1.07v-6.84c0-2.72,1.48-4.12,4.12-4.12H146.46z"
        />
      </g>
      <line
        id="Line_7"
        fill="none"
        :stroke="lineColor"
        x1="164.5"
        y1="0"
        x2="164.5"
        y2="40"
      />
      <g>
        <path
          :fill="subtitleColor"
          d="M183.57,14.07c0,0.31-0.03,0.61-0.08,0.9s-0.15,0.62-0.29,0.97c-0.14,0.35-0.34,0.65-0.57,0.9s-0.56,0.46-0.98,0.64c-0.42,0.17-0.9,0.26-1.45,0.26c-1.37,0-2.32-0.44-2.85-1.31c-0.53-0.87-0.79-2.18-0.79-3.93c0-3.48,1.22-5.22,3.65-5.22c0.56,0,1.05,0.1,1.48,0.29c0.42,0.2,0.75,0.43,0.97,0.69c0.22,0.27,0.4,0.58,0.53,0.93c0.13,0.35,0.22,0.65,0.25,0.89c0.03,0.24,0.05,0.46,0.05,0.68h-1.13c-0.09-1.68-0.82-2.52-2.17-2.52c-0.42,0-0.78,0.08-1.09,0.25c-0.31,0.16-0.55,0.37-0.72,0.63c-0.17,0.26-0.31,0.58-0.41,0.98c-0.1,0.4-0.17,0.78-0.2,1.14c-0.03,0.36-0.04,0.79-0.04,1.27c0,0.38,0.01,0.71,0.02,0.97c0.01,0.26,0.04,0.58,0.09,0.94c0.05,0.37,0.13,0.67,0.24,0.92c0.11,0.24,0.26,0.48,0.43,0.72c0.18,0.24,0.41,0.42,0.71,0.53c0.29,0.12,0.63,0.18,1.02,0.18c0.37,0,0.7-0.06,0.96-0.18c0.27-0.12,0.48-0.26,0.62-0.42c0.14-0.16,0.26-0.37,0.36-0.64c0.09-0.27,0.15-0.49,0.18-0.66c0.02-0.17,0.05-0.39,0.08-0.65c0-0.02,0-0.03,0-0.05c0-0.01,0-0.03,0.01-0.05c0-0.02,0.01-0.04,0.01-0.06H183.57z"
        />
        <path
          :fill="subtitleColor"
          d="M184.75,12.52c0-0.96,0.09-1.79,0.28-2.49c0.19-0.7,0.45-1.24,0.79-1.62c0.34-0.38,0.71-0.66,1.12-0.84c0.41-0.18,0.86-0.27,1.35-0.27c1.07,0,1.93,0.41,2.58,1.22c0.64,0.81,0.97,2.15,0.97,4c0,0.81-0.06,1.53-0.19,2.15c-0.12,0.62-0.3,1.12-0.51,1.5s-0.48,0.7-0.79,0.94c-0.31,0.24-0.63,0.41-0.96,0.5c-0.33,0.09-0.69,0.13-1.09,0.13s-0.77-0.04-1.09-0.13c-0.33-0.09-0.65-0.25-0.96-0.48c-0.31-0.23-0.58-0.54-0.79-0.92c-0.21-0.38-0.38-0.89-0.51-1.51C184.81,14.06,184.75,13.34,184.75,12.52z M185.91,12.52c0,1.09,0.11,1.96,0.31,2.6c0.21,0.64,0.48,1.08,0.81,1.31c0.33,0.23,0.75,0.34,1.25,0.34c0.8,0,1.4-0.31,1.79-0.92s0.59-1.72,0.59-3.34c0-1.55-0.2-2.65-0.6-3.29c-0.4-0.64-0.99-0.97-1.78-0.97s-1.38,0.32-1.78,0.97C186.11,9.87,185.91,10.97,185.91,12.52z"
        />
        <path
          :fill="subtitleColor"
          d="M193.21,7.53h1.47l1.79,5.07l1.88-5.07h1.4v9.97h-1.12V9.56l-1.85,5.02h-0.66l-1.78-5.02v7.93h-1.12V7.53z"
        />
        <path
          :fill="subtitleColor"
          d="M201.4,7.53h1.47l1.79,5.07l1.89-5.07h1.4v9.97h-1.12V9.56l-1.85,5.02h-0.66l-1.78-5.02v7.93h-1.12V7.53z"
        />
        <path
          :fill="subtitleColor"
          d="M215.28,17.5l-0.77-2.58h-3.41l-0.76,2.58h-1.19l2.97-9.97h1.15l3.29,9.97H215.28z M211.38,13.97h2.85l-1.43-4.83L211.38,13.97z"
        />
        <path
          :fill="subtitleColor"
          d="M217.89,7.53h1.26l3.93,7.83V7.53h1.12v9.97H223l-3.99-7.94v7.94h-1.12V7.53z"
        />
        <path
          :fill="subtitleColor"
          d="M226.09,7.53h1.88c1.8,0,3.05,0.38,3.76,1.15c0.7,0.77,1.06,1.98,1.06,3.64c0,1.75-0.36,3.06-1.09,3.91c-0.73,0.85-1.97,1.27-3.72,1.27h-1.88V7.53z M228,16.53c1.31,0,2.24-0.31,2.79-0.92c0.56-0.62,0.83-1.7,0.83-3.26c0-1.4-0.25-2.39-0.74-2.97c-0.49-0.58-1.43-0.87-2.81-0.87h-0.85v8.02H228z"
        />
        <path
          :fill="subtitleColor"
          d="M234.44,7.53h5.94V8.5h-4.82v3.39h4.31v0.97h-4.31v3.68h4.86v0.97h-5.98V7.53z"
        />
        <path
          :fill="subtitleColor"
          d="M242.65,7.53h2.72c0.48,0,0.89,0.04,1.25,0.11c0.36,0.08,0.69,0.21,1,0.39s0.54,0.46,0.71,0.83c0.16,0.36,0.25,0.81,0.25,1.33c0,0.85-0.17,1.5-0.53,1.96c-0.35,0.46-0.87,0.77-1.56,0.94l2.34,4.41h-1.32l-2.17-4.3h-1.57v4.3h-1.12V7.53z M245.31,12.24c0.69,0,1.21-0.14,1.57-0.41c0.36-0.28,0.53-0.81,0.53-1.59c0-0.38-0.05-0.7-0.15-0.95c-0.1-0.25-0.26-0.42-0.48-0.53c-0.22-0.11-0.43-0.18-0.64-0.21c-0.21-0.03-0.48-0.05-0.81-0.05h-1.55v3.74H245.31z"
        />
        <path
          :fill="subtitleColor"
          d="M252.9,7.53h1.81v1.22c0,1.4-0.59,2.2-1.76,2.39v-1.01c0.3-0.1,0.51-0.23,0.64-0.39c0.13-0.16,0.18-0.36,0.17-0.62h-0.85V7.53z"
        />
        <path
          :fill="subtitleColor"
          d="M259.79,14.35c0.04,0.78,0.27,1.37,0.69,1.79c0.42,0.42,1.02,0.62,1.79,0.62c0.66,0,1.14-0.15,1.45-0.44c0.3-0.29,0.46-0.75,0.46-1.35c0-0.36-0.09-0.66-0.28-0.92c-0.19-0.26-0.43-0.47-0.73-0.62c-0.3-0.16-0.63-0.31-0.99-0.45c-0.36-0.14-0.72-0.29-1.09-0.44c-0.37-0.15-0.71-0.33-1.01-0.54c-0.3-0.21-0.55-0.49-0.74-0.84c-0.19-0.35-0.28-0.76-0.28-1.23c0-0.8,0.25-1.44,0.75-1.92s1.22-0.72,2.15-0.72c1.02,0,1.78,0.29,2.27,0.88s0.76,1.33,0.78,2.21h-1.12c-0.08-1.41-0.73-2.11-1.95-2.11c-1.15,0-1.72,0.54-1.72,1.63c0,0.46,0.18,0.85,0.53,1.17s0.78,0.57,1.27,0.77c0.49,0.2,0.99,0.4,1.5,0.61s0.94,0.52,1.29,0.94c0.35,0.42,0.52,0.94,0.52,1.57c0,0.91-0.27,1.6-0.8,2.08c-0.53,0.48-1.29,0.72-2.27,0.72c-1.21,0-2.11-0.32-2.69-0.95s-0.87-1.44-0.87-2.44H259.79z"
        />
      </g>
      <g>
        <path
          :fill="subtitleColor"
          d="M176.95,20.53h1.12v4.37h4.03v-4.37h1.12v9.97h-1.12v-4.63h-4.03v4.63h-1.12V20.53z"
        />
        <path
          :fill="subtitleColor"
          d="M184.75,25.52c0-0.96,0.09-1.79,0.28-2.49c0.19-0.7,0.45-1.24,0.79-1.62c0.34-0.38,0.71-0.66,1.12-0.84c0.41-0.18,0.86-0.27,1.35-0.27c1.07,0,1.93,0.41,2.58,1.22c0.64,0.81,0.97,2.15,0.97,4c0,0.81-0.06,1.53-0.19,2.15c-0.12,0.62-0.3,1.12-0.51,1.5s-0.48,0.7-0.79,0.94c-0.31,0.24-0.63,0.41-0.96,0.5c-0.33,0.09-0.69,0.13-1.09,0.13s-0.77-0.04-1.09-0.13c-0.33-0.09-0.65-0.25-0.96-0.48c-0.31-0.23-0.58-0.54-0.79-0.92c-0.21-0.38-0.38-0.89-0.51-1.51C184.81,27.06,184.75,26.34,184.75,25.52z M185.91,25.52c0,1.09,0.11,1.96,0.31,2.6c0.21,0.64,0.48,1.08,0.81,1.31c0.33,0.23,0.75,0.34,1.25,0.34c0.8,0,1.4-0.31,1.79-0.92s0.59-1.72,0.59-3.34c0-1.55-0.2-2.65-0.6-3.29c-0.4-0.64-0.99-0.97-1.78-0.97s-1.38,0.32-1.78,0.97C186.11,22.87,185.91,23.97,185.91,25.52z"
        />
        <path
          :fill="subtitleColor"
          d="M193.28,20.53h1.12v6.44c0,1.05,0.17,1.77,0.52,2.18c0.35,0.41,0.87,0.61,1.55,0.61c0.69,0,1.22-0.19,1.59-0.58c0.37-0.39,0.55-1.09,0.55-2.12v-6.52h1.11v6.52c0,1.27-0.26,2.2-0.79,2.79s-1.35,0.88-2.46,0.88c-1.15,0-1.97-0.29-2.46-0.86c-0.49-0.57-0.74-1.51-0.74-2.81V20.53z"
        />
        <path
          :fill="subtitleColor"
          d="M202.46,27.35c0.04,0.78,0.27,1.37,0.69,1.79c0.42,0.42,1.02,0.62,1.79,0.62c0.66,0,1.15-0.15,1.45-0.44c0.3-0.29,0.46-0.75,0.46-1.35c0-0.36-0.09-0.66-0.28-0.92c-0.19-0.26-0.43-0.47-0.73-0.62c-0.3-0.16-0.63-0.31-0.99-0.45c-0.36-0.14-0.72-0.29-1.09-0.44c-0.37-0.15-0.71-0.33-1.01-0.54c-0.3-0.21-0.55-0.49-0.73-0.84c-0.19-0.35-0.28-0.76-0.28-1.23c0-0.8,0.25-1.44,0.75-1.92c0.5-0.48,1.22-0.72,2.15-0.72c1.02,0,1.78,0.29,2.28,0.88c0.5,0.59,0.76,1.33,0.78,2.21h-1.12c-0.08-1.41-0.73-2.11-1.95-2.11c-1.15,0-1.72,0.54-1.72,1.63c0,0.46,0.18,0.85,0.53,1.17s0.78,0.57,1.27,0.77c0.49,0.2,0.99,0.4,1.5,0.61s0.94,0.52,1.29,0.94c0.35,0.42,0.52,0.94,0.52,1.57c0,0.91-0.27,1.6-0.8,2.08c-0.53,0.48-1.29,0.72-2.27,0.72c-1.21,0-2.11-0.32-2.69-0.95c-0.58-0.63-0.87-1.44-0.87-2.44H202.46z"
        />
        <path
          :fill="subtitleColor"
          d="M209.87,20.53h5.94v0.97h-4.82v3.39h4.31v0.97h-4.31v3.68h4.86v0.97h-5.98V20.53z"
        />
        <path
          :fill="subtitleColor"
          d="M231.66,30.5l-0.77-2.58h-3.41l-0.76,2.58h-1.19l2.97-9.97h1.15l3.29,9.97H231.66z M227.76,26.97h2.85l-1.43-4.83L227.76,26.97z"
        />
        <path
          :fill="subtitleColor"
          d="M234.28,20.53h2.98c0.49,0,0.93,0.04,1.3,0.11c0.37,0.08,0.73,0.21,1.08,0.39c0.35,0.19,0.61,0.47,0.79,0.85c0.18,0.38,0.27,0.84,0.27,1.39c0,2.04-1.2,3.07-3.58,3.07h-1.72v4.16h-1.12V20.53z M237.07,25.38c0.81,0,1.43-0.14,1.86-0.42s0.64-0.81,0.64-1.6c0-0.7-0.18-1.19-0.54-1.46s-0.94-0.41-1.76-0.41h-1.86v3.88H237.07z"
        />
        <path
          :fill="subtitleColor"
          d="M242.47,20.53h2.98c0.49,0,0.93,0.04,1.3,0.11c0.37,0.08,0.73,0.21,1.08,0.39s0.61,0.47,0.79,0.85s0.27,0.84,0.27,1.39c0,2.04-1.19,3.07-3.58,3.07h-1.72v4.16h-1.12V20.53z M245.26,25.38c0.81,0,1.43-0.14,1.85-0.42c0.43-0.28,0.64-0.81,0.64-1.6c0-0.7-0.18-1.19-0.54-1.46s-0.94-0.41-1.76-0.41h-1.86v3.88H245.26z"
        />
      </g>
    </svg>
    <span v-if="appMode === 'onpremise'">
      A collaberation between 4D Research Lab (UvA) and SPINLab (VU)
    </span>
    <span v-if="appMode === 'onpremise'">Powered by Potree</span>
  </div>
</template>

<script>
export default {
  name: 'TheLogo',
  props: {
    titleColor: {
      type: String,
      required: true,
    },
    subtitleColor: {
      type: String,
      required: true,
    },
    lineColor: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      appMode: process.env.VUE_APP_MODE,
    };
  },
};
</script>

<style scoped>
#logo {
  width: 20rem;
  display: flex;
  flex-direction: column;
}

span {
  color: white;
  font-size: x-small;
  margin-top: 0.3rem;
}
</style>
